import { Option } from "../../components/select/Select";

export const getNumber: (str: string | number) => number = str =>
  Number(String(str).replace(/[^\d.]/g, "")) || 0;

export const getOptionsFromArray: (
  strArray: string[] | number[]
) => Option[] = strArray => {
  return strArray.map(str => ({ label: str, value: str }));
};

export const getQueryParams: (
  params: Record<string, any>
) => string = params => {
  const processedParams = Object.entries(params).reduce(
    (obj, [key, value]) =>
      value === undefined || value === null
        ? obj
        : { ...obj, [key]: String(value) },
    {}
  );
  return new URLSearchParams(processedParams).toString();
};

export const getCardinalStr: (num: number) => string = num => {
  const lastDigit = String(num).split("").pop();
  switch (lastDigit) {
    case "1":
      return `${num}st`;
    case "2":
      return `${num}nd`;
    case "3":
      return `${num}rd`;
    default:
      return `${num}th`;
  }
};
